import { Link } from "react-router-dom";
import { Shield, FileText, Info, Copyright } from "lucide-react";

export const DashboardFooter = () => {
  return (
    <footer className="border-t border-border/40 bg-[#1A1F2C] dark:bg-[#0F1219]">
      <div className="py-2 px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <Shield className="h-4 w-4 text-primary" />
              <h3 className="font-semibold text-xs text-white">Security</h3>
            </div>
            <p className="text-[11px] text-white/60">
              Your data is protected with enterprise-grade security
            </p>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <FileText className="h-4 w-4 text-primary" />
              <h3 className="font-semibold text-xs text-white">Legal</h3>
            </div>
            <div className="space-y-0.5 text-[11px]">
              <Link to="/privacy" className="block text-white/60 hover:text-primary transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="block text-white/60 hover:text-primary transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
          
          <div className="space-y-1">
            <div className="flex items-center gap-2">
              <Info className="h-4 w-4 text-primary" />
              <h3 className="font-semibold text-xs text-white">Support</h3>
            </div>
            <div className="space-y-0.5 text-[11px]">
              <Link to="/dashboard/help" className="block text-white/60 hover:text-primary transition-colors">
                Help Center
              </Link>
              <Link to="/dashboard/support" className="block text-white/60 hover:text-primary transition-colors">
                Contact Support
              </Link>
            </div>
          </div>
        </div>
        
        <div className="mt-2 pt-1 border-t border-border/40 flex items-center justify-center gap-2 text-[11px] text-white/60">
          <Copyright className="h-3 w-3" />
          <span>{new Date().getFullYear()} Tradeco Legal Services. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};